import { Grade } from 'types/schema-generated-types';

type GradeShorthand = 'PK' | 'K' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';

export const getGrade = (gradeLevel: string): Grade =>
  ({
    PK: Grade.PK,
    K: Grade.K,
    '1': Grade.FIRST,
    '2': Grade.SECOND,
    '3': Grade.THIRD,
    '4': Grade.FOURTH,
    '5': Grade.FIFTH,
    '6': Grade.SIXTH,
    '7': Grade.SEVENTH,
    '8': Grade.EIGHTH
  }[gradeLevel as GradeShorthand]);

export const sortGrade = (gradeLevelA: string, gradeLevelB: string): number => {
  const sortedGrades = ['PK', 'K', '1', '2', '3', '4', '5', '6', '7', '8'];
  return sortedGrades.indexOf(gradeLevelA) - sortedGrades.indexOf(gradeLevelB);
};

export const gradeDropdownItems = [
  { value: 'PK', name: 'Pre-K' },
  { value: 'K', name: 'K' },
  { value: '1', name: 1 },
  { value: '2', name: 2 },
  { value: '3', name: 3 },
  { value: '4', name: 4 },
  { value: '5', name: 5 },
  { value: '6', name: 6 },
  { value: '7', name: 7 },
  { value: '8', name: 8 }
];
